export const AddressTypeDTO = {
  BUSINESS: 'BUSINESS',
  OPERATIONAL: 'OPERATIONAL',
};
